<div class="md-content rd-3">
  <i class="material-icons md-close" (click)="cancel()">close</i>
  <div class="w-100 text-center mb-3">
    @if (type === 'booking') {
      <h3>{{ 'CONFIRM_DRAG.change_booking' | translate }}</h3>
    }
    @if (type === 'holiday') {
      <h3>{{ 'CONFIRM_DRAG.change_holiday' | translate }}</h3>
    }
    @if (type === 'booking') {
      <p class="subtext">{{event?.client?.firstName}}@if (event?.client?.lastName) {
        <span> {{event?.client?.lastName}}</span>
      } / {{event?.service?.name}}</p>
    }
  </div>
  <div class="container mb-3">
    <div class="row">
      <div class="col-md-6">
        <div class="booking-slot old rd-3">
          <p class="strong">{{ 'CONFIRM_DRAG.before' | translate }}</p>
          <p class="text-capitalize">{{oldStart | date: 'EEEE, d MMMM':undefined:currentLocale}}</p>
          <p>{{oldStart | date: timeFormatShort}} - {{oldEnd | date: timeFormatShort}}</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="booking-slot new rd-3">
          <p class="strong">{{ 'CONFIRM_DRAG.now' | translate }}</p>
          <p class="text-capitalize">{{newStart | date: 'EEEE, d MMMM':undefined:currentLocale}}</p>
          <p>{{newStart | date: timeFormatShort}} - {{newEnd | date: timeFormatShort}}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center mb-3">
    @if (startChanged && type === 'booking') {
      <div>
        <div class="custom-control custom-checkbox mt-3">
          <input
            [(ngModel)]="notifyClient"
            type="checkbox"
            class="custom-control-input"
            id="notify-client"
            />
          <label class="custom-control-label" for="notify-client">
            {{ 'CONFIRM_DRAG.notify_client' | translate }}
          </label>
        </div>
      </div>
    }
  </div>

  <app-alert type="danger" [msg]="errorMsg" />

  <div class="d-flex justify-content-center">
    <button type="button" class="btn btn-md btn-secondary mr-2" (click)="cancel()">
      {{ 'CONFIRM_DRAG.cancel' | translate }}
    </button>
    <button [disabled]="saving" type="button" class="btn btn-md btn-primary" (click)="confirm()">
      {{ 'CONFIRM_DRAG.confirm' | translate }}
    </button>
  </div>

</div>
